export const MEET_VIDEO_CONSTRAINTS = Object.freeze({
  width: Object.freeze({ ideal: 960, max: 1280 }),
  height: Object.freeze({ ideal: 540, max: 720 }),
  frameRate: Object.freeze({ ideal: 22, max: 24 }),
});

const MEET_ADAPTIVE_PROFILES = Object.freeze([
  Object.freeze({ name: 'clear', maxBitrate: 1_150_000, maxFramerate: 22, scaleResolutionDownBy: 1 }),
  Object.freeze({ name: 'standard', maxBitrate: 850_000, maxFramerate: 20, scaleResolutionDownBy: 1.25 }),
  Object.freeze({ name: 'resilient', maxBitrate: 550_000, maxFramerate: 18, scaleResolutionDownBy: 1.5 }),
]);

export const MEET_VIDEO_ENCODING = Object.freeze({
  ...MEET_ADAPTIVE_PROFILES[1],
  degradationPreference: 'maintain-framerate',
  adaptiveProfiles: MEET_ADAPTIVE_PROFILES,
  initialProfile: 1,
  adaptationIntervalMs: 3000,
});
